module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/1-2-1-4962ec87e922c01ee3a229d69ad0535a.png";